import {useFormik} from "formik";
import React, {useContext, useEffect, useState} from "react";
import {StoreContext} from "../../../store/StoreContext";
import * as yup from "yup";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import {changePassword, sigIn} from "../../../api/access";
import {toast} from "../../../alerts/sweetalert";
import {dropLocal} from "../../../helpers/local-storage";
import {LOCAL_SESSION} from "../../../constants/local-entity";
import {useNavigate} from "react-router-dom";

const Password = () => {
  const navigate = useNavigate();
  const {setAppTitle, session, setSession} = useContext(StoreContext);

  const [loading, setLoading] = useState(false);
  const [isPassOldPass, setIsPassTypeOldPass] = useState(true);
  const [isPassNewPass, setIsPassTypeNewPass] = useState(true);
  const [isPassRepeatPass, setIsPassTypeRepeatPass] = useState(true);
  const [equalsError, setEqualsError] = useState(false);

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
    },
    validationSchema: yup.object({
      oldPassword: yup.string().required("Completa este campo"),
      newPassword: yup.string().required("Completa este campo"),
      repeatPassword: yup.string().required("Completa este campo"),
    }),
    onSubmit: ({oldPassword, newPassword, repeatPassword}) => {
      if (newPassword !== repeatPassword) {
        setEqualsError(true);
        return;
      }

      setEqualsError(false);
      setLoading(true);
      sigIn(session.username, oldPassword)
        .then(res => {
          const sessionAux = res?.data[0];
          if (sessionAux.Respuesta !== 1) throw new Error();
          return changePassword(session.username, newPassword);
        })
        .then(res => {
          const sessionAux = res?.data[0];
          if (sessionAux.Respuesta !== 1) throw new Error();

          formik.resetForm();
          return toast({
            icon: "success",
            title: "Cambio de contraseña con éxito.",
          });
        })
        .then(() => {
          dropLocal(LOCAL_SESSION);
          setSession(null);
          navigate("/");
        })
        .catch(err => alert("La contraseña antigua no es correcta."))
        .finally(() => setLoading(false));
    },
  });

  const oldPasswordError =
    formik.touched.oldPassword && Boolean(formik.errors.oldPassword);
  const oldPasswordHelperText =
    formik.touched.oldPassword && formik.errors.oldPassword;

  const newPasswordError =
    formik.touched.newPassword && Boolean(formik.errors.newPassword);
  const newPasswordHelperText =
    formik.touched.newPassword && formik.errors.newPassword;

  const repeatPasswordError =
    formik.touched.repeatPassword && Boolean(formik.errors.repeatPassword);
  const repeatPasswordHelperText =
    formik.touched.repeatPassword && formik.errors.repeatPassword;

  useEffect(() => {
    setAppTitle("Cambio de contraseña");
  }, []);

  return (
    <div className="row mt-3">
      <div className="col-12">
        <p className="text-center fw-bold fs-6 mb-5">
          Formulario de cambio de contraseña
        </p>
      </div>

      <div className="col-12 col-md-4 mx-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label htmlFor="input-old-password" className="form-label">
              Contraseña anterior
            </label>
            <div className="input-group">
              <input
                type={isPassOldPass ? "password" : "text"}
                className={`form-control ${
                  oldPasswordError ? "is-invalid" : ""
                }`}
                id="input-old-password"
                aria-describedby="emailHelp"
                name="oldPassword"
                disabled={loading}
                value={formik.values.oldPassword}
                onChange={formik.handleChange}
              />
              <span
                className="input-group-text cursor-pointer"
                onClick={() => setIsPassTypeOldPass(prev => !prev)}
              >
                {isPassOldPass ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
            </div>
            {oldPasswordError && (
              <div className="invalid-feedback d-block">
                {oldPasswordHelperText}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="input-new-password" className="form-label">
              Nueva contraseña
            </label>
            <div className="input-group">
              <input
                type={isPassNewPass ? "password" : "text"}
                className={`form-control ${
                  newPasswordError || equalsError ? "is-invalid" : ""
                }`}
                id="input-new-password"
                aria-describedby="emailHelp"
                name="newPassword"
                disabled={loading}
                value={formik.values.newPassword}
                onChange={formik.handleChange}
              />
              <span
                className="input-group-text cursor-pointer"
                onClick={() => setIsPassTypeNewPass(prev => !prev)}
              >
                {isPassNewPass ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
            </div>
            {newPasswordError && (
              <div className="invalid-feedback d-block">
                {newPasswordHelperText}
              </div>
            )}
            {equalsError && (
              <div className="invalid-feedback d-block">
                Las contraseñas no coinciden
              </div>
            )}
          </div>
          <div className="mb-3">
            <label htmlFor="input-repeat-password" className="form-label">
              Confirmar contraseña
            </label>
            <div className="input-group">
              <input
                type={isPassRepeatPass ? "password" : "text"}
                className={`form-control ${
                  repeatPasswordError || equalsError ? "is-invalid" : ""
                }`}
                id="input-repeat-password"
                aria-describedby="emailHelp"
                name="repeatPassword"
                disabled={loading}
                value={formik.values.repeatPassword}
                onChange={formik.handleChange}
              />
              <span
                className="input-group-text cursor-pointer"
                onClick={() => setIsPassTypeRepeatPass(prev => !prev)}
              >
                {isPassRepeatPass ? (
                  <FontAwesomeIcon icon={faEyeSlash} />
                ) : (
                  <FontAwesomeIcon icon={faEye} />
                )}
              </span>
            </div>
            {repeatPasswordError && (
              <div className="invalid-feedback d-block">
                {repeatPasswordHelperText}
              </div>
            )}
            {equalsError && (
              <div className="invalid-feedback d-block">
                Las contraseñas no coinciden
              </div>
            )}
          </div>

          <div className="d-flex">
            <button
              type="submit"
              className="btn bg-primary ms-auto px-4 text-white"
              disabled={loading}
            >
              Enviar
              {loading && (
                <div
                  className="spinner-border spinner-border-sm ms-2"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Password;
